import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Select } from '@components/atoms/select'

import { minMaxOptions } from '@config/data'

export const StrengthTraining = memo(({ state, onChange }) => {
  return (
    <>
      <div className="text-slate-600">How many days a week will you commit to strength training?</div>
      <div className="flex space-x-4 mt-8">
        <Select
          name="strengthTrainingMin"
          label="Min"
          value={state.strengthTrainingMin}
          onChange={onChange}
          list={minMaxOptions}
        />
        <Select
          name="strengthTrainingMax"
          label="Max"
          value={state.strengthTrainingMax}
          onChange={onChange}
          list={minMaxOptions.slice(state.strengthTrainingMin)}
        />
      </div>
    </>
  )
})

StrengthTraining.propTypes = {
  state: PropTypes.object,
  onChange: PropTypes.func,
}